export default __webpack_public_path__ + "img/BB_RT_250MA_EF.7f9f8f06b2b8480cee71cb6625764ef4.jpg";